import React, { useState, useEffect, useRef } from 'react'

const JSONInput = ({ value, onChange, isDarkMode, error }) => {
  const [lineNumbers, setLineNumbers] = useState('1')
  const textareaRef = useRef(null)
  const lineNumbersRef = useRef(null)

  // Update line numbers when content changes
  useEffect(() => {
    const lines = value.split('\n').length
    const numbers = Array.from({ length: lines }, (_, i) => i + 1).join('\n')
    setLineNumbers(numbers)
  }, [value])

  // Sync scroll between textarea and line numbers
  const handleScroll = () => {
    if (textareaRef.current && lineNumbersRef.current) {
      lineNumbersRef.current.scrollTop = textareaRef.current.scrollTop
    }
  }

  return (
    <div className="editor-container" style={{ position: 'relative' }}>
      <div className="editor-with-lines" style={{ height: '500px' }}>
        {/* Line numbers */}
        <div
          ref={lineNumbersRef}
          className="line-numbers"
        >
          {lineNumbers}
        </div>
        
        {/* Textarea */}
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onScroll={handleScroll}
          placeholder="Paste your JSON here..."
          style={{
            flex: 1,
            height: '100%',
            minHeight: '500px',
            padding: '12px',
            border: 'none',
            backgroundColor: 'var(--input-bg)',
            color: 'var(--text-color)',
            fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
            fontSize: '14px',
            lineHeight: '1.5',
            resize: 'vertical',
            outline: 'none',
            overflow: 'auto'
          }}
        />
      </div>
      
      {error && (
        <div className="error-message">
          <strong>Error:</strong> {error}
        </div>
      )}
    </div>
  )
}

export default JSONInput
